import React, { Component } from 'react'
import axios from 'axios';
import {BrowserRouter, NavLink, Route ,Switch} from 'react-router-dom';
import {App} from './App';
import { withRouter } from "react-router";
import {Table} from 'react-bootstrap';
import {Button,ButtonToolbar} from 'react-bootstrap';
import {EditTopicTechMapping} from './EditTopicTechMapping';
import Multiselect from 'multiselect-react-dropdown';
import queryString from 'query-string';
class AdminTopicTechMapping extends Component {
  constructor (props){
    super(props);
    this.state = {
        TopicList:[],
        DomainList:[],
        TaskList:[],
        techlist:[],
        TechList:[],
        TechListAll:[],
        levellist:[],
        options: [],
        servicegroup:"",
        addModalShow:false,
        editModalShow:false,
        TaskId:"",
        username:"",
        isLoading: false 
    }               
}

Domainchange(e) {
  this.state.App = e.target.value;
  document.getElementById('ddlTech').disabled = false;
  axios.get("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Index/TechnologyListIO/"+e.target.value)
  .then(res=> {            
    this.setState ( { techlist: res.data } )
      })
      .catch(err => {
        console.log(err);
    }) 
}

componentDidMount() {
  if(document.referrer == ""){
    window.location.replace('https://as-mobilization-stage.accenture.com/Nest-Home.aspx');
  }
  else{
    this.setState({isLoading: true})
  fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopicTech/Get/"+"1"+";"+"2").then(response => response.json())
  .then(res=> {            
    this.setState ( { TopicList: res} )
      })
      .catch(err => {
        console.log(err);
    }) 
    console.log(this.state.TopicList);

    this.handleQueryString();

    fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopicTech/GetTechnology").then(response => response.json())
    .then(res=> {            
      this.setState ( { TechListAll:res } )
        })
        .catch(err => {
          console.log(err);
      }) 
    console.log(this.state.TechListAll);

    fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopic/GetTasks/"+"1"+";"+"2").then(response => response.json())
    .then(res=> {            
      this.setState ( { TaskList: res} )
        })
        .catch(err => {
          console.log(err);
      }) 
      console.log(this.state.TaskList);
      document.title ="KTPlanConfigurator";
    }
   
}
handleQueryString = () => {
  let queries = queryString.parse(window.location.search)
  if(queries.username !=undefined)
  {
    this.state.username = queries.username;
  }
}
TopicClick() {

  this.props.history.push({

    pathname: '/AdminTopics',
    search:"?username="+this.state.username,
  })  
}
TechClick() {

  this.props.history.push({

    pathname: '/AdminTechnology',
    search:"?username="+this.state.username,
  })  
}
TasksClick() {

  this.props.history.push({

    pathname: '/AdminTasks',
    search:"?username="+this.state.username,
  })  
}

TasksHeaderClick() {

  this.props.history.push({

    pathname: '/AdminTaskHeader',
    search:"?username="+this.state.username,
  })  
}


Techchange(e){
  this.state.tech = e.target.value;
  fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopic/GetTasksIO/"+this.state.tech+";"+"3").then(response => response.json())
  .then(res=> {            
    this.setState ( { TaskList: res} )
      })
      .catch(err => {
        console.log(err);
    }) 
    console.log(this.state.TaskList);
}

getscope() {
  fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Index/ScopeList/"+this.state.servicegroup).then(response => response.json())
  .then(res=> {            
    this.setState ( { options:res } )
      })
      .catch(err => {
        console.log(err);
    }) 
}




SGChange(e) {
  if(e.target.value != "Select" && e.target.value == "AO")
  {
  this.state.servicegroup = e.target.value;
  
  this.getlevel();
  this.getscope();
  document.getElementById('divAO').style.display = 'block'
  document.getElementById('divIE').style.display = 'none'
  }

if(e.target.value != "Select" && e.target.value == "IE")
  {
  this.state.servicegroup = e.target.value;
  this.getdomain();
  document.getElementById('divIE').style.display = 'block'
  document.getElementById('divAO').style.display = 'none'
  }
}

getlevel() {
  fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Index/LevelList/"+this.state.servicegroup).then(response => response.json())
  .then(res=> {            
    this.setState ( { levellist: res } )
      })
      .catch(err => {
        console.log(err);
    }) 

    

}

getdomain() {
  fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopic/Domains").then(response => response.json())
  .then(res=> {            
    this.setState ( { DomainList: res } )
      })
      .catch(err => {
        console.log(err);
    }) 
}

onSelect(selectedList, selectedItem) {
  this.state.test ="";
 for(let i=0;i<selectedList.length;i++)
 {
   this.state.test += ","+selectedList[i].value;
 }
 if(this.state.test.toString().includes("1") && this.state.test.toString().length<=2)
 {

 
  this.state.level = "";
 }
 else
 {
  
  this.state.level = "2";
 }
 console.log(this.state.test);
}

onRemove(selectedList, removedItem) {

  this.state.test ="";
  for(let i=0;i<selectedList.length;i++)
  {
    this.state.test += ","+selectedList[i].value;
  }
  if(this.state.test.toString().includes("1") && this.state.test.toString().length<=2)
 {
 
  this.state.level = "";
 }
 else if(this.state.test.toString().includes("2") || this.state.test.toString().includes("3"))
 {
 
  this.state.level = "2";
 }
 else
 {
  
  this.state.level = "";
 }
  console.log(this.state.test);
}

Levelchange(e) {

  this.state.level = e.target.value;
  fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopic/GetTasks/"+this.state.test+";"+(this.state.level.toString()==""?3:this.state.level)).then(response => response.json())
  .then(res=> {            
    this.setState ( { TaskList: res} )
      })
      .catch(err => {
        console.log(err);
    }) 
    console.log(this.state.TaskList);

}
TopicTechdefaultClick() {

  this.props.history.push({

    pathname: '/AdmindefaultTopicTechMapping',
    search:"?username="+this.state.username,
  })  
}
adminClick(){

  this.props.history.push({

    pathname: '/',
    
    state: {  username:this.state.username},
    search:"?username="+this.state.username,
})
}

  filterClick() {
    document.getElementById('divTable').style.display = 'block';
    if(this.state.servicegroup == "AO")
    {
    fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopicTech/Get/"+this.state.test+";"+(this.state.level.toString()==""?3:this.state.level)+";"+this.state.TaskId).then(response => response.json())
    .then(res=> {            
      this.setState ( { TopicList: res} )
        })
        .catch(err => {
          console.log(err);
      }) 
      console.log(this.state.TopicList);

      
    }
    if(this.state.servicegroup =="IE")
    {
      fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopicTech/GetIO/"+this.state.tech+";"+"3"+";"+this.state.TaskId).then(response => response.json())
      .then(res=> {            
        this.setState ( { TopicList: res} )
          })
          .catch(err => {
            console.log(err);
        }) 
        console.log(this.state.TopicList);


      
    }

     
  }

render() {
  
  const {TaskId,TopicId,Phase,UseCase,Topic,Description,TaskName,username} = this.state;
    let addModalClose=()=>this.setState({addModalShow:false});
    let editModalClose=()=>this.setState({editModalShow:false});
    return (
      this.state.isLoading ? (
        <div class="bg-background" style={{background:'#F2F2F2'}}>
        <div class="row">
            <div class="container-fluid">
            <div class="header-content" style={{marginLeft:17}}>
              <img src="images/Capture.png" style={{paddingBottom:5}} alt="Accenture Technology" class="img-icon" />
              <span class="new-KT-navbar" style={{marginLeft:5}}>KT Plan Configurator</span>
              <button type='button' style={{marginLeft:850,marginTop:5}}  className='btn-new btn-confirm' onClick={() => this.adminClick()}>KT Plan</button>

          </div>
              <div class="demographic-form margin-top15 border-main-div new-KT" style={{height:500,overflow:'auto'}} >
                

              <div class="col-md-12 ">
              <div class="ul-financials margin-bottom15">
              <a class="active control-label" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TechClick()}>Technology</a>
              <a  Text="Header" style={{marginRight:50,color:'black',fontWeight:'bold'}}  ID="lnkTasksHeaders" onClick={() => this.TasksHeaderClick()}>Tasks Header Maintenance</a>
              <a  Text="Tasks" class="control-label" style={{marginRight:50,color:'black',fontWeight:'bold'}}  ID="lnkTasks" onClick={() => this.TasksClick()} >Tasks Maintenance</a>
                <a Text="Topic" class="control-label" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicClick()} ID="lnkTopic" >Topic Maintenance</a>
                <a  Text="Topic Technology" class="control-label" style={{marginRight:50,color:'black',fontWeight:'bold',borderBottom:2,borderBottomColor:'#7500c0',borderBottom:'solid',paddingBottom:5}}  >Topic-Technology Mapping</a>
                <a  Text="Topic Technology default" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicTechdefaultClick()} >Default Technology</a>

            </div>
<div class="col-md-3" >
      <label for=" " class="control-label margin-bottom5  margin-top5" >Service Group *</label>
      <select style={{width:275,height:37}} onChange={(e) => this.SGChange(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id="ContentPlaceHolder1_ddlIncludeGovernance" class="aspNetDisabled form-control input-sm   textarea-style watermark">
      <option value="Select">Select</option>
      <option value="AO">AMS</option>
      <option value="IE">IMS</option>
     
      </select>
     
    </div>
    <div id='divAO' style={{display:'block'}}>
    <div class="col-md-3" id='mlScope'>
         <label for=" " class="control-label margin-bottom5  margin-top5" >What is the scope of support? *</label>
       
         <Multiselect
         
         options={this.state.options} 
         selectedValues={this.state.selectedValue} 
         onSelect={this.onSelect.bind(this)} 
         onRemove={this.onRemove.bind(this)}
         avoidHighlightFirstOption={true}
         displayValue="text" 
         ref={this.multiselectRef2}
         />
       
        </div>

        <div class="col-md-3">
         <label for=" " class="control-label margin-bottom5  margin-top5" >What is the level of support? *</label>
         <select style={{width:275,height:36}} onChange={(e) => this.Levelchange(e)}  name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlLevel' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
         <option>Select</option>
          {
              
              this.state.levellist.map(list =>
                   <option value={list.value}>{list.text}</option>)
           }
         </select>
        
       </div>

       <div class="col-md-3">
         <label for=" " class="control-label margin-bottom5  margin-top5" >TaskName *</label>
         <select style={{width:275,height:36}} onClick={(e)=>this.setState({TaskId:e.target.value})}  name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlTask' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
         <option>Select</option>
          {
              
              this.state.TaskList.map(list =>
                   <option value={list.taskid}>{list.task_name}</option>)
           }
         </select>
        
       </div>

       </div>
       <div  id='divIE'  style={{display:'none'}}>
       <div class="col-md-3">
         <label for=" " class="control-label margin-bottom5  margin-top5" >What is the Domain? *</label>
         <select  style={{height:38}} onChange={(e) => this.Domainchange(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlDomain' class=" form-control input-sm   textarea-style  margin-bottom5 watermark">
                   <option value='Select'>Select</option>
                  
                   {
                        
                        this.state.DomainList.map(list =>
                             <option value={list.value} >{list.text}</option>)
                     }

                   </select>
        
       </div>
       <div class="col-md-3">
         <label for=" " class="control-label margin-bottom5  margin-top5" >What is the Tower? *</label>
         <select style={{width:275,height:38,display:'block',disabled:true}} onChange={(e) => this.Techchange(e)}  name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id='ddlTech' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
                      <option>Select</option>
                      {
                           
                           this.state.techlist.map(list =>
                                <option value={list.value} key={list.text} >{list.text}</option>)
                        }

                      </select>
        
       </div>

       <div class="col-md-3">
         <label for=" " class="control-label margin-bottom5  margin-top5" >TaskName *</label>
         <select style={{width:275,height:36}} onClick={(e)=>this.setState({TaskId:e.target.value})}  name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlTask' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
         <option>Select</option>
          {
              
              this.state.TaskList.map(list =>
                   <option value={list.taskid}>{list.task_name}</option>)
           }
         </select>
        
       </div>

       </div>

         <button type='button' onClick={() => this.filterClick()}  className='btn-new'  >Filter</button>

</div>
              <div id='divTable' style={{display:'none'}}>
              <div class="col-md-12 " style={{marginTop:5}} >
                   
                     
                    </div>
                 <Table className='mt-4' striped bordered hover size='sm'>
                   <thead style={{background:'#e6dcff'}}>
                       <tr>
                       <th>Topic Id</th>
                       <th>Task Name</th>
                       <th>KT Phase</th>
                       <th>Topic</th>
                       <th>UseCase</th>
                       <th>Description</th>
                       <th>Unique Identifier</th>
                       <th></th>
                       </tr>
                   </thead>
                   <tbody>
                       {
                       this.state.TopicList.map(obj=>
                       <tr key={obj.topicsid}>
                            <td>{obj.topicsid}</td>
                            <td>{obj.task_name}</td>
                            <td>{obj.KTPhase}</td>
                            <td>{obj.Topic}</td>
                            <td>{obj.UseCase}</td>
                            <td>{obj.Description}</td>
                            <td>{obj.topics_uniqueidentifier}</td>
                            <td>
                              <ButtonToolbar>
                                <img src="images/edit-new.png" className='mr-2' variant='info'  onClick={()=>                            
                                this.setState({editModalShow:true,
                                TopicId:obj.topicsid,TaskId:obj.taskid,Phase:obj.KTPhase,
                                UseCase:obj.UseCase,Topic:obj.Topic,Description:obj.Description,
                                TaskName:obj.task_name})}/>
                               
                               
                              </ButtonToolbar>
                            </td>
                       </tr>
                       )}
                   </tbody>
                 </Table>
                 </div>
                  </div>
                  </div>
                  </div>
                 
                  <ButtonToolbar>

                   
                               <EditTopicTechMapping show={this.state.editModalShow}
                               onHide={editModalClose}
                               TopicId={TopicId} TaskId={TaskId} Phase={Phase} UseCase={UseCase}
                               Topic={Topic} Description={Description} TaskName={TaskName}
                               TechList={this.state.TechList}
                               TechListAll = {this.state.TechListAll}
                               username = {this.state.username}
                               
                               ></EditTopicTechMapping>
                                
                  </ButtonToolbar>



                  </div>)
                  :
                  (<div>Invalid Session, Please login again..</div>)
    )
}
}
export default withRouter(AdminTopicTechMapping);
